(function () {
	const splitScreenSlid = () => {
		$(".split-screen-slideshow__section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".js-slideshow-get-params");
const autoplay = box.data("autoplay");
const stopAutoplay = box.data("stop-autoplay");
const delay = box.data("delay") * 1000;
const isSingleSlide = box.data("single-slide");
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			} else {
				autoplayParm = { autoplay: false };
			}
			let swiperParms = {
	parallax: box.data("parallax"),
	effect: box.data("effect"),
	speed: box.data("speed") * 1000,
	creativeEffect: {
		prev: {
			shadow: false,
			translate: [0, 0, -400],
		},
		next: {
			translate: ["100%", 0, 0],
		},
	},
	coverflowEffect: {
		rotate: 50,
		stretch: 0,
		depth: 100,
		modifier: 1,
		slideShadows: false,
	},
	flipEffect: {
		slideShadows: false,
	},
	loop: !isSingleSlide,
	allowTouchMove: !isSingleSlide,
	...(isSingleSlide ? { autoplay: false } : autoplayParm),
};
			const swiperImg = new Swiper(
				`#${id} .split-screen-slideshow__image-swiper`,
				{ ...swiperParms, autoplay: false, allowTouchMove: false }
			);
			const swiperText = new Swiper(
	`#${id} .split-screen-slideshow__text-swiper`,
	{
		navigation: {
			nextEl: `#${id} .swiper-button-next`,
			prevEl: `#${id} .swiper-button-prev`,
		},
		pagination: {
			el: `#${id} .swiper-pagination`,
			clickable: true,
		},
		preventClicks: false,
		preventClicksPropagation: false,
		touchStartPreventDefault: false,
		...swiperParms,
	}
);
			swiperImg.controller.control = swiperText;
			swiperText.controller.control = swiperImg;
			colorScheme(swiperText);

			function hideSwiperDuplicates(swiperInstance) {
				swiperInstance.slides.forEach((slideEl) => {
					if (slideEl.classList.contains("swiper-slide-duplicate")) {
						slideEl.setAttribute("aria-hidden", "true");
						slideEl.setAttribute("inert", "");
						slideEl
							.querySelectorAll("a, button, h1, h2, h3, h4, h5, h6")
							.forEach((el) => el.setAttribute("tabindex", "-1"));
					}
				});
			}

			hideSwiperDuplicates(swiperImg);
			hideSwiperDuplicates(swiperText);

			swiperImg.on("loopFix", function () {
				hideSwiperDuplicates(swiperImg);
			});
			swiperText.on("loopFix", function () {
				hideSwiperDuplicates(swiperText);
			});
		swiperText.on("beforeTransitionStart", function () {
			colorScheme(this);
		});
		function colorScheme(context) {
			const activeIndex = context.activeIndex;
			const activeSlide = context.slides[activeIndex];
			const changeItems = [
				context.navigation.nextEl,
				context.navigation.prevEl,
				context.pagination.el,
			];
			const colorScheme = $(activeSlide).data("color-scheme");
			changeItems.forEach((item) => {
				$(item)
					.removeClass("color-background-1")
					.removeClass("color-background-4")
					.addClass(colorScheme);
			});
		}

		document.querySelectorAll('.about__carousel-video').forEach(function(video) {
			video.setAttribute('preload', 'auto');
			video.play().catch(function() {});
			video.addEventListener('playing', function() {
				video.classList.add('is-playing');
			});
		});
	});
};

	document.addEventListener("DOMContentLoaded", function () {
		splitScreenSlid();
	});
	document.addEventListener("shopify:section:load", function () {
		splitScreenSlid();
	});
})();